// Persists permission grants per plugin in localStorage (with the app's `slate:`
// prefix). Web-safe: a missing or malformed entry just reads as "no grants".

import type { GrantStore } from './permissionBroker';

const keyFor = (pluginId: string): string => `slate:plugin-grants:${pluginId}`;

export const localStorageGrantStore: GrantStore = {
  get(pluginId) {
    try {
      const raw = localStorage.getItem(keyFor(pluginId));
      return raw ? (JSON.parse(raw) as Record<string, boolean>) : undefined;
    } catch {
      return undefined;
    }
  },
  set(pluginId, grants) {
    try {
      localStorage.setItem(keyFor(pluginId), JSON.stringify(grants));
    } catch {
      /* storage unavailable / quota — grants simply do not persist */
    }
  },
};
